<template>
  <modal-default
    ref="commCallModal"
    subtitle="CALL"
    :title="contact.full_name"
  >
    <app-loading-section :loading="isLoading">
      <form-field-select-contact-numbers
        v-model="selectedContactNumber"
        :contact="contact"
        :validation-errors="validationErrors.contact_number"
      />

      <form-field-select-integration-phone-number
        v-model="selectedPhoneNumberId"
        :has-empty-option="false"
        :validation-errors="validationErrors.integrationPhoneNumber"
      />

      <template v-if="! isSmrtPhoneNumber">
        <form-field-input
          label="Your Cell Number"
          v-model="form.user_number"
          help-text="We will connect your cell phone with the Integration number"
          :validation-errors="validationErrors.user_number"
        />
      </template>

      <form-field-select-leads
        v-if="availableRecords"
        v-model="form.record_id"
        :records="availableRecords"
      />

      <hr>

      <p class="call_modal--hint"><strong>TIP</strong> Enable one-click calling in your <a @click="openProfileModal">profile</a>
        to automatically call the contact's primary number when you hit the call button.</p>
    </app-loading-section>

    <!--Footer-->
    <template v-slot:footer>
      <a
        v-if="isSmrtPhoneNumber"
        class="button is-small is-primary"
        style="line-height: 28px"
        :href="smrtPhoneContactNumber"
        :data-from="smrtPhoneFromNumber"
        :data-text="false"
        :data-lead-id="form.record_id"
        @click="close()"
      >Start Call</a>

      <button-default
        v-else
        :loading="isCalling"
        :disabled="isCalling"
        @click="call()"
      >Start Call
      </button-default>
    </template>
  </modal-default>
</template>

<script>
import {ENUMS} from "../../services/enums";
import router from "../../router";
import api from "../../api";

export default {
  name: "CommCallModal",
  props: {
    contact: {
      type: Object,
      required: true
    },
    record: Object,
    availableRecords: Array,
  },
  data() {
    return {
      isLoading: true,
      isCalling: false,
      defaultForm: {
        record_id: null,
        user_number: this.$store.state.activeUser.outbound_call_cell_number,
        contact_number: null,
        integrationPhoneNumber: null,
      },
      form: null,
      lastCall: null,
      selectedContactNumber: null,
      selectedPhoneNumberId: null,
      validationErrors: {},
    };
  },
  computed: {
    phoneNumbers() {
      return this.$store.getters.integrationPhoneNumbers;
    },
    campaign() {
      let campaignId = this.record ? this.record.campaign_id : null;
      return this.$store.getters.campaigns.find(campaign => campaign.id === campaignId);
    },
    selectedPhoneNumber() {
      if (this.selectedPhoneNumberId) {
        const number = this.phoneNumbers.find(number => number.id === this.selectedPhoneNumberId);
        // This is here to troubleshoot in prod
        console.log('selectedPhoneNumber:', `${number.label} - ${number.number}`)
        return number;
      }
      return null;
    },
    isSmrtPhoneNumber() {
      if (this.selectedPhoneNumber) {
        const integration = this.$store.getters.integrations.find(integration => integration.id === this.selectedPhoneNumber.integration_id);

        return integration.type === ENUMS.IntegrationTypeEnum.SmrtPhone.value;
      }

      return false;
    },
    smrtPhoneContactNumber() {
      if (this.selectedContactNumber) {
        const number = 'tel:' + this.selectedContactNumber.value.replace(/[^0-9]/g, '')
        console.log('smrtPhoneContactNumber:', number) // troubleshoot in prod
        return 'tel:' + this.selectedContactNumber.value.replace(/[^0-9]/g, '')
      }
      console.log('smrtPhoneContactNumber is null') // troubleshoot in prod
      return null;
    },
    smrtPhoneFromNumber() {
      if (this.selectedPhoneNumber) {
        const number = this.selectedPhoneNumber.number.replace(/[^0-9]/g, '')
        // This is here to troubleshoot in prod
        console.log('smrtPhoneFromNumber:', `${this.selectedPhoneNumber.label} - ${number}`)
        return number
      }

      // This is here to troubleshoot in prod
      console.log('smrtPhoneFromNumber is null')

      return null;
    },
  },
  created() {
    this.form = this.defaultForm;
    this.form.record_id = (this.record && !this.availableRecords) ? this.record.id : null;

    // Set attached record if there is only one availableRecord
    if (this.availableRecords && this.availableRecords.length === 1) {
      this.form.record_id = this.availableRecords[0].id;
    }
  },
  methods: {
    open() {
      this.init();
      this.$refs.commCallModal.open();
      this.$emit("open");
    },
    close() {
      this.$refs.commCallModal.close();
      this.$emit("close");
    },
    openProfileModal() {
      this.$refs.commCallModal.close();
      this.$emit("close");
      router.replace({query: {modal: 'profile'}});
    },
    init() {
      // Get last call and save it so we can set initial selected phone number
      api.communicationLogs.lastCall(this.contact.id).then((response) => {
        this.lastCall = response.data;
      }).finally(() => {
        // Set initial selected phone number
        this.setInitialSelectedPhoneNumberId();
        this.isLoading = false;
      });
    },
    setInitialSelectedPhoneNumberId() {
      // Get last call number if one exists
      let lastCallNumber = undefined

      if(this.lastCall.tracking_number) {
        lastCallNumber = this.phoneNumbers.find(number => number.number === this.lastCall.tracking_number);
      }

      // If there is a last call number use that number
      if (lastCallNumber) {
        this.selectedPhoneNumberId = lastCallNumber.id;
      }
      // If not, set it to the campaign number
      else if (this.campaign && this.campaign.integrationPhoneNumber) {
        this.selectedPhoneNumberId = this.campaign.integrationPhoneNumber.id;
      }
      // If not, then just use the first number in the list
      else if (this.phoneNumbers.length) {
        this.selectedPhoneNumberId = this.phoneNumbers[0].id;
      }
    },
    call() {
      this.form.contact_number = this.selectedContactNumber.value;
      this.form.integrationPhoneNumber = this.selectedPhoneNumber;

      if (this.form.integrationPhoneNumber === null) {
        this.$buefy.toast.open({message: "Please Select a From Number", type: "is-danger"});

        return;
      }

      this.isCalling = true;

      api.integrationPhoneNumbers.callContact(this.contact.id, this.form)
        .then(() => {
          this.form.integrationPhoneNumber = null;
          this.$refs.commCallModal.close();
          this.$buefy.toast.open({
            message: `The call was started and will ring ${this.form.user_number}`,
            type: "is-success"
          });
        }, error => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
        }).finally(() => {
        this.isCalling = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.call_modal--hint {
  font-size: 0.875rem;

  a {
    text-decoration: underline;
  }
}
</style>
